import { Typography, makeStyles } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

const useStyles = makeStyles((theme)=> ({
  textDefaultStyle: {
    paddingLeft: theme.spacing(2)
  }
}))

function InlineText(props) {
  const classes = useStyles();
  const { title, text, loading } = props;
  const { titleProps, textProps } = props;
  return (
    <div style={{display: 'flex'}}>
      <Typography {...titleProps}>{title}:</Typography>
      <Typography 
        className={classes.textDefaultStyle} 
        color='textSecondary' 
        {...textProps}
      >
        {loading? <Skeleton width={100}/>: text}
      </Typography>
    </div>
  )
}

export default InlineText;